import * as React from 'react';

// matches a `[placeholder]` token inside a prompt string, e.g. "Show me order [case ID]."
export const PROMPT_PLACEHOLDER = /\[[^\]]+]/;

// renders a prompt string with its [placeholder] tokens styled distinctly from the surrounding text
export const renderPromptLibraryText = (prompt: string): React.ReactNode =>
    prompt.split(/(\[[^\]]+])/).map((part, idx) => {
        if (!/^\[[^\]]+]$/.test(part)) return part;
        return React.createElement('span', { key: idx, className: 'text-content-medium' }, part);
    });

// a prompt "requires input" (fill the composer instead of sending immediately) when it has a
// [placeholder] to complete, or when its metadata explicitly says it needs an attachment first
export const promptRequiresInput = (prompt: string, meta?: { requiresAttachment?: boolean }): boolean =>
    PROMPT_PLACEHOLDER.test(prompt) || !!meta?.requiresAttachment;

export const promptTemplateStillMatches = (template: string, message: string): boolean => {
    const literalSegments = template
        .split(/\[[^\]]+]/g)
        .map((segment) => segment.trim())
        .filter(Boolean);
    return literalSegments.length > 0 && literalSegments.every((segment) => message.includes(segment));
};
